import { orUndefined, schAlertType, schAloftArea } from '@aloft/toolkit-shared';

import { AlertDefinition } from '../../types.ts';
import {
  UnitRateFeatureCheck,
  checkInconsistentUnitRateAdjustments,
} from '../utils/checkInconsistentUnitRateAdjustments.ts';

const GLA_DEVIATION_THRESHOLD = 0.1;
const SITE_SIZE_DEVIATION_THRESHOLD = 0.2;
const GLA_MIN_ABSOLUTE_UNIT_DIFFERENCE = 100;
const SITE_SIZE_MIN_ABSOLUTE_UNIT_DIFFERENCE = 1000;

const FEATURE_CHECKS: UnitRateFeatureCheck[] = [
  {
    label: 'GLA',
    manualKey: 'gla',
    unitRateKey: 'mainDwelling',
    adjustmentCellKeyId: 'gla',
    threshold: GLA_DEVIATION_THRESHOLD,
    minAbsoluteUnitDifference: GLA_MIN_ABSOLUTE_UNIT_DIFFERENCE,
    unit: 'SF',
    getUnitAmount: (editableData) =>
      orUndefined(schAloftArea.parse)(editableData.improvements?.gla)?.toSqFt().unitAmount,
  },
  {
    label: 'Site Size',
    manualKey: 'site',
    unitRateKey: 'siteSize',
    adjustmentCellKeyId: 'site',
    threshold: SITE_SIZE_DEVIATION_THRESHOLD,
    minAbsoluteUnitDifference: SITE_SIZE_MIN_ABSOLUTE_UNIT_DIFFERENCE,
    unit: 'SF',
    getUnitAmount: (editableData) =>
      orUndefined(schAloftArea.parse)(editableData.site?.area)?.toSqFt().unitAmount,
  },
];

export const inconsistentAdjustmentRate: AlertDefinition = (params) =>
  checkInconsistentUnitRateAdjustments({
    ...params,
    alertType: schAlertType.enum.inconsistentAdjustmentRate,
    severity: 'error',
    featureChecks: FEATURE_CHECKS,
    fixingMethod: ['comment', 'action'],
  });
